import React from "react";

const MarkIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.689"
      height="22.68"
      viewBox="0 0 14.689 22.68"
    >
      <path
        id="ic_turned_in_not_24px"
        d="M17.591,3H7.1A2.338,2.338,0,0,0,5.01,5.52L5,25.68l7.345-3.78,7.345,3.78V5.52A2.345,2.345,0,0,0,17.591,3Zm0,18.9-5.246-2.747L7.1,21.9V5.52H17.591Z"
        transform="translate(-5 -3)"
        fill={color}
      />
    </svg>
  );
};

export default MarkIcon;
